import { useTranslations } from '@vocab/react';
import { Button, Inline, Stack, Text } from 'braid-design-system';
import React, { useEffect } from 'react';

import { useUpdateShareableProfileSettings } from 'src/components/Profile/ProfileVisibilityV2/data';
import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useAppConfig } from 'src/modules/appConfig';

import translations from './.vocab';

export const InactiveReminder = ({ closeFn }: { closeFn: () => void }) => {
  const { t } = useTranslations(translations);
  const { zone, language } = useAppConfig();

  const [updateShareableProfileSettings] =
    useUpdateShareableProfileSettings(true);

  const { shareableProfileShareViewed, shareableProfileShareLinkClicked } =
    useAnalytics();

  useEffect(() => {
    shareableProfileShareViewed({
      eventName: 'profile_link_share_prompt_displayed',
      currentPage: 'profile',
      profileSharedStatus: 'off',
    });
    // run once during on load only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickHandler = () => {
    closeFn();
    shareableProfileShareLinkClicked({
      eventName: 'profile_update_succeeded',
      currentPage: 'profile',
      profileSharedStatus: 'on',
      actionOrigin: 'profile',
      updateType: 'edit',
    });
    updateShareableProfileSettings({
      active: true,
      zone,
      languageCode: language,
    });
  };

  return (
    <Stack space="gutter">
      <Text tone="secondary">{t('When your shared profile is off...')}</Text>
      <Inline space="small">
        <Button
          tone="formAccent"
          id="turn-on-shareable-profile-btn"
          data={{ automation: 'turn-on-shareable-profile-btn' }}
          onClick={onClickHandler}
        >
          {t('Turn on')}
        </Button>
        <Button variant="transparent" tone="formAccent" onClick={closeFn}>
          {t('Cancel')}
        </Button>
      </Inline>
    </Stack>
  );
};
